<template>
  <div class="container">
    <form>
      <div>
        <label>收货人</label>
        <input id="name" type="text" placeholder="请输入收货人姓名">
      </div>
      <div>
        <label>手机号码</label>
        <input id="phone" type="number" placeholder="请输入收货人手机号码">
      </div>
      <div class="last-input">
        <label>详细地址</label>
        <textarea name="address" id="address" cols="20" rows="3" placeholder="请输入收货人详细地址"></textarea>
      </div>
      <router-link to="/lottery">
        <button class="save">保存</button>
      </router-link>
    </form>
  </div>
</template>

<script>
export default {
  name: 'addAddress'
}
</script>

<style scoped>
.container {
  width: 375px;
  height: 690px;
  padding-top: 4px;
  font-size: 15px;
  background-color: #fff;
}

label {
  display: inline-block;
  padding-left: 12px;
  width: 84px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
}

input, textarea {
  width: 279px;
  height: 40px;
  padding: 10px 8px;
  margin-top: 12px;
  background: #F5F5F5;
  border-radius: 10px;
  font-weight: 400;
}

.last-input label {
  vertical-align: top;
  padding-top: 22px;
}

textarea {
  height: 80px;
}

.save {
  display: block;
  width: 252px;
  height: 36px;
  margin: 426px auto 0;
  background: #096CEF;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
}

::placeholder {
  color: #999;
  opacity: 1;
}

</style>
